import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { portalFetchReceipts } from "../../services/portalApi";
import PortalShell from "./PortalShell";
import "./portal.css";

const formatMoney = (n) =>
  `₹${(parseFloat(n) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatDate = (d) => {
  if (!d || d === "0000-00-00") return "—";
  try {
    return new Date(`${d}T12:00:00`).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

export default function PortalReceipts() {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const rows = await portalFetchReceipts();
        setReceipts(rows);
      } catch (err) {
        toast.error(err.message || "Could not load payment history");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <PortalShell
      title="Payment history"
      subtitle="Receipts recorded against your invoices."
    >
      {loading ? (
        <p className="portal-empty">Loading payments…</p>
      ) : receipts.length === 0 ? (
        <div className="portal-empty">No payments recorded yet.</div>
      ) : (
        receipts.map((r) => (
          <article key={r.id} className="portal-card">
            <div className="portal-card__row">
              <div>
                <h2 className="portal-card__title">
                  {r.receipt_number || `Receipt #${r.id}`}
                </h2>
                <p className="portal-card__meta">
                  Invoice {r.invoiceNumber || "—"} · {formatDate(r.receiptDate)}
                </p>
              </div>
              <span className="portal-amount">{formatMoney(r.amount)}</span>
            </div>
            <p className="portal-card__meta" style={{ marginTop: "0.5rem" }}>
              {r.payment_method === "online_razorpay"
                ? "Paid online"
                : r.payment_method || "Payment"}
              {r.payment_reference ? ` · Ref ${r.payment_reference}` : ""}
            </p>
          </article>
        ))
      )}
    </PortalShell>
  );
}
